import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/AdminDashboard';
import ExpertDashboard from './pages/ExpertDashboard';
import InvestorDashboard from './pages/InvestorDashboard';
import Marketplace from './pages/Marketplace';
import ObserverDashboard from './pages/ObserverDashboard';
import VerifyPage from './pages/VerifyPage';
import Landing from './pages/Landing';
import PublicPlantProfile from './pages/PublicPlantProfile';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import InvestorsPage from './pages/InvestorsPage';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify" element={<VerifyPage />} />
        <Route path="/plant/:id" element={<PublicPlantProfile />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/investors" element={<InvestorsPage />} />
        
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />

        <Route path="/admin" element={
          <ProtectedRoute allowedRoles={['admin']}>
            <AdminDashboard />
          </ProtectedRoute>
        } />

        <Route path="/dashboard/expert" element={
          <ProtectedRoute allowedRoles={['expert']}>
            <ExpertDashboard />
          </ProtectedRoute>
        } />
        
        <Route path="/dashboard/investor" element={
          <ProtectedRoute allowedRoles={['investor']}>
            <InvestorDashboard />
          </ProtectedRoute>
        } />

        <Route path="/dashboard/investor/marketplace" element={
          <ProtectedRoute allowedRoles={['investor']}>
            <Marketplace />
          </ProtectedRoute>
        } />

        <Route path="/dashboard/observer" element={
          <ProtectedRoute allowedRoles={['observer']}>
            <ObserverDashboard />
          </ProtectedRoute>
        } />


        {/* Catch-all redirects to landing */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
